import { AlertOutlined, CloseOutlined } from '@ant-design/icons';
import { Empty } from 'antd';
import { useNotificationRead } from 'features/Dashboard/use-cases/notification-read';
import { useSideBar } from 'providers/side-bar-provider';
import { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { NotificationValue } from 'types/notification-dashboard';

export const NotificationDocuments = ({ notification, refetch }: any) => {
  const { notificationCollapsed } = useSideBar();
  const navigate = useNavigate(); // Initialize navigation
  const { mutate } = useNotificationRead();
  const notificationRead = (item: any) => {
    const formData = new FormData();
    formData.append('NotificationId', item?.notificationId);
    mutate(formData, {
      onSuccess: () => {
        refetch();
      },
    });
  };
  const handleCloseNotification = (item: any) => {
    notificationRead(item);
  };
  const handleNotificationClick = (item: any) => {
    if (
      item?.notificationTitle === NotificationValue.Adminrequesttouploaddocument
    ) {
      notificationRead(item);
      navigate(`/documents?activeTab=${'2'}`); // Replace with the correct route
    } else if (
      item?.notificationTitle === NotificationValue.Adminapproveddocument
    ) {
      notificationRead(item);
      navigate(`/documents?activeTab=${'1'}`); // Replace with the correct route
    } else if (
      item?.notificationTitle === NotificationValue.Adminrejectdocument
    ) {
      notificationRead(item);
      navigate(`/documents?activeTab=${'3'}`); // Replace with the correct route
    } else if (
      item?.notificationTitle === NotificationValue.Adminuploadreportdocument
    ) {
      notificationRead(item);
      navigate('/management-report'); // Replace with the correct route
    } else if (
      item?.notificationTitle === NotificationValue.Adminapprovedlegaldocument
    ) {
      notificationRead(item);
      navigate('/legal-documents'); // Replace with the correct route
    } else if (
      item?.notificationTitle === NotificationValue.Adminrejectlegaldocument
    ) {
      notificationRead(item);
      navigate('/legal-documents'); // Replace with the correct route
    } else {
      notificationRead(item);
    }
  };

  return (
    <Fragment>
      <div
        className={`notificationCart dscell rtbx transition-all shadow-lg rounded-lg right-0 ${
          !notificationCollapsed ? 'translate-x-full' : ''
        }`}
      >
        <div className='card '>
          <div>
            <div className='head'>
              <h3>Notifications</h3>
            </div>
            {Array.isArray(notification?.rc) && notification?.rc.length ? (
              notification?.rc.map((item: any, index: number) => {
                return (
                  <div className='nitybx' key={index}>
                    <div className='nblst'>
                      <div className='nlicon'>
                        <AlertOutlined />
                      </div>
                      <div
                        className='nl_vlu'
                        role='button'
                        onClick={() => handleNotificationClick(item)}
                      >
                        <h3>{item?.notificationTitle}</h3>
                        <h6>{item?.notificationBody}</h6>
                        <p>{item?.notificationTime}</p>
                      </div>
                      <div
                        role='button'
                        onClick={() => handleCloseNotification(item)}
                      >
                        <CloseOutlined />
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <Empty description={'No Notification'} />
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};
